import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class Expired {
  /* 过期产品列表 */
  static getExpiredProductsList(options) {
    let url = `/zwy/api/expired/products/deal/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 录入 */
  static postExpiredProducts(data) {
    const url = `/zwy/api/expired/products/deal/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 完成处理 */
  static postFinishExpired(data) {
    const url = `/zwy/api/expired/products/deal/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Expired;